import { render } from "./ClientTccRemainder.vue?vue&type=template&id=3acedff4&scoped=true"
import script from "./ClientTccRemainder.vue?vue&type=script&lang=js"
export * from "./ClientTccRemainder.vue?vue&type=script&lang=js"

import "./ClientTccRemainder.vue?vue&type=style&index=0&id=3acedff4&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acedff4"]])

export default __exports__